import { __awaiter } from "tslib";
import { Editor as TipTapEditor, EditorContent } from '@tiptap/vue-3';
import Text from '@tiptap/extension-text';
import { InputDocNode, EnterBreakNode, ParagraphNode } from '@getaccept/editor-lib-new';
import { defineComponent, watch, ref, onMounted, onBeforeUnmount, computed, nextTick } from 'vue';
export default defineComponent({
    name: 'ProsemirrorViewerInput',
    components: {
        EditorContent,
    },
    props: {
        content: {
            type: [Object, String],
            default: () => ({}),
        },
    },
    emits: ['loaded'],
    setup(props, { emit }) {
        const viewer = ref(null);
        watch(() => props.content, () => {
            var _a;
            (_a = viewer.value) === null || _a === void 0 ? void 0 : _a.commands.setContent(props.content);
        });
        const inputViewer = computed(() => ({
            content: props.content,
            editable: false,
            extensions: [InputDocNode, ParagraphNode, Text, EnterBreakNode],
            onCreate: handleLoaded,
            enableInputRules: false,
            enablePasteRules: false,
        }));
        const handleLoaded = () => __awaiter(this, void 0, void 0, function* () {
            yield nextTick();
            emit('loaded');
        });
        onMounted(() => {
            viewer.value = new TipTapEditor(inputViewer.value);
        });
        onBeforeUnmount(() => {
            var _a;
            (_a = viewer.value) === null || _a === void 0 ? void 0 : _a.destroy();
        });
        return {
            viewer,
            handleLoaded,
        };
    },
});
